import { toast } from "sonner";
import { registerSW } from "virtual:pwa-register";

/**
 * Register the app-shell service worker. Updates wait for the user ("prompt") so an open form is
 * never reloaded underneath them.
 */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || import.meta.env.DEV) return;
  const updateSW = registerSW({
    onNeedRefresh() {
      toast("A new version of Supperkeep is ready.", {
        id: "sw-update",
        duration: Infinity,
        action: { label: "Reload", onClick: () => void updateSW(true) },
      });
    },
    onOfflineReady() {
      toast.success("Supperkeep can now open without a connection.", { id: "sw-offline-ready" });
    },
  });
}
